import PropTypes from "prop-types";
import React from "react";
import { getClassNameFactory } from "../../../../utilities/classNames";
import MultiSelectDropdown from "../MultiSelectDropdown";

var TagFilter = function TagFilter(_ref) {
  var index = _ref.index,
      handleChange = _ref.handleChange,
      label = _ref.label,
      noOptionsMessage = _ref.noOptionsMessage,
      options = _ref.options,
      placeholder = _ref.placeholder,
      value = _ref.value;
  var getClassName = getClassNameFactory(TagFilter.displayName);
  var name = label.replace(/\s+/g, "_") + index;
  /* eslint-disable jsx-a11y/label-has-for */

  return (
    /*#__PURE__*/
    // Control is wrapped in <label>
    React.createElement("div", null, label && /*#__PURE__*/React.createElement("label", {
      htmlFor: name
    }, /*#__PURE__*/React.createElement("span", {
      className: getClassName({
        descendantName: "label"
      })
    }, label)), /*#__PURE__*/React.createElement(MultiSelectDropdown, {
      handleChange: handleChange,
      name: name,
      noOptionsMessage: noOptionsMessage,
      options: options,
      placeholder: placeholder,
      value: value
    }))
  );
  /* eslint-enable jsx-a11y/label-has-for */
};

TagFilter.displayName = "TableWithFilters.TagFilter";
TagFilter.propTypes = {
  /**
   * On change event handler
   */
  handleChange: PropTypes.func.isRequired,

  /**
   * Remove selected tag from available filter options
   */
  index: PropTypes.number.isRequired,

  /**
   * Label for the input
   */
  label: PropTypes.string,

  /**
   * Message displayed in the filter if there is no option resulting from the typeahead input
   */
  noOptionsMessage: PropTypes.string.isRequired,

  /**
   * Data to generate listed options
   */
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string
  })),

  /**
   * Placeholder for the filter input
   */
  placeholder: PropTypes.string.isRequired,

  /**
   * Data to generate selected options
   */
  value: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string
  }))
};
TagFilter.defaultProps = {
  isMulti: true,
  noOptionsMessage: "No results found that match your search term. Please try another or check your spelling.",
  placeholder: "Add filter(s)...",
  hideSelectedOptions: false
};
export default TagFilter;